import { InternalValuationReviewService } from "../services/internalValuationReviewService";

export const PROPERTY_COMP_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
export const PROPERTY_COMP_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

const service = new InternalValuationReviewService();

//stored path -> object URL. The path is unique per upload, so a cached photo never goes stale.
const imageUrls = new Map<string, string>();
const pendingImages = new Map<string, Promise<string | null>>();

//photos that come from the comp tool are plain URLs, the ones uploaded from the VTR form are stored paths
export const isRemoteImage = (value: string) => /^https?:\/\//i.test(value || "");

export const getCachedPropertyCompImage = (path: string): string | undefined => imageUrls.get(path);

//the stored photos can't be loaded by the browser from their path: they are downloaded with the user session
export const loadPropertyCompImage = (propertyCompId: number, path: string): Promise<string | null> =>
  loadStoredImage(path, () => service.getPropertyCompImage(propertyCompId));

//the photo uploaded for the subject (it is stored in the review, not in a comp)
export const loadSubjectImage = (loanId: number, propertyId: number, path: string): Promise<string | null> =>
  loadStoredImage(path, () => service.getSubjectImage(loanId, propertyId));

const loadStoredImage = (path: string, download: () => Promise<any>): Promise<string | null> => {
  const cached = imageUrls.get(path);
  if (cached) {
    return Promise.resolve(cached);
  }
  const pending = pendingImages.get(path);
  if (pending) {
    return pending;
  }
  const request = download()
    .then(response => {
      const blob = response?.data;
      if (!(blob instanceof Blob) || blob.size === 0) {
        return null;
      }
      const url = URL.createObjectURL(blob);
      imageUrls.set(path, url);
      return url;
    })
    .catch(() => null)
    .finally(() => pendingImages.delete(path));
  pendingImages.set(path, request);
  return request;
};
